<template>
  <t-form labelWidth="90px">
    <CptDefault :attribute="attribute" :currentCpt="currentCpt"/>
    <t-form-item label="计时方式">
      <t-radio-group v-model="attribute.direction" size="small">
        <t-radio-button :value="1">顺时</t-radio-button>
        <t-radio-button :value="0">倒计时</t-radio-button>
      </t-radio-group>
    </t-form-item>
    <t-form-item :label="attribute.direction === 1 ? '起始时间':'截止时间'">
      <t-date-picker style="width: 100%" enable-time-picker allow-input v-model="attribute.targetTime"/>
    </t-form-item>
    <t-form-item label="显示格式">
      <t-select v-model="attribute.accuracy" size="small">
<!--        <t-option label="年" value="1"/>-->
        <t-option label="天" :value="2"/>
        <t-option label="天/时" :value="3"/>
        <t-option label="天/时/分" :value="4"/>
        <t-option label="天/时/分/秒" :value="5"/>
      </t-select>
    </t-form-item>
    <t-form-item label="显示年">
      <t-switch v-model="attribute.showYear" size="small" :label="['开', '关']"/>
    </t-form-item>
    <t-form-item label="数值字体">
      <t-select v-model="attribute.num.fontFamily" size="small">
        <t-option v-for="item in textFamilyList" :key="item.value" :label="item.label" :value="item.value"/>
      </t-select>
    </t-form-item>
    <t-form-item label="数值颜色">
      <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.num.color" size="small"/>
    </t-form-item>
    <t-form-item label="数值大小">
      <t-input-number :min="13" :max="200" v-model="attribute.num.fontSize"  size="small" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="label颜色">
      <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.label.color" size="small"/>
    </t-form-item>
    <t-form-item label="label大小">
      <t-input-number :min="13" :max="200" v-model="attribute.label.fontSize"  size="small" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="label位置">
      <t-radio-group v-model="attribute.label.align" size="small">
        <t-radio-button value="top">顶部</t-radio-button>
        <t-radio-button value="center">居中</t-radio-button>
        <t-radio-button value="bottom">底部</t-radio-button>
      </t-radio-group>
    </t-form-item>
  </t-form>
</template>

<script>
import CptDefault from '@/components/element/options/comp/cpt-default'

export default {
  name: "cpt-time-run-option",
  components: { CptDefault } ,
  props: {attribute: Object,currentCpt:Object,},
  data() {
    return {
      textFamilyList:[]
    }
  },
  created() {
    this.textFamilyList = require('@/assets/font/font-list')
  }
}
</script>

<style scoped>

</style>
